// ** Custom Components
import Name from "./Name";
import VipStatus from "./VipStatus";

// ** Utils & Helpers
import generatePath from "utils/generatePath";

// ** Routes
import routes from "containers";

// #####################################################

const fontSizes = {
	large: "1.3rem",
	base: "1.25rem",
	mbase: "1.15rem",
	xbase: "1.1rem",
	medium: "1rem",
	small: "1rem",
	xsmall: "0.85rem",
	xxsmall: "0.8rem",
	xxxsmall: "0.8rem",
};

// #####################################################

const Login = ({
	login,
	vip,
	vipProps,
	link,
	size,
	maxWidthWithEllipsis,
	scrollForce,
	closeModal,
	isProfile,
	noUnderline,
	...rest
}) => {
	const statusVip =
		vip > 1 || vipProps?.showUnverified ? (
			<VipStatus
				status={vip}
				height={vipProps?.height || 12}
				{...vipProps}
			/>
		) : null;

	const to = generatePath(routes.user.path, {
		login: login?.toLowerCase(),
	});

	// #####################################################

	return (
		<Name
			content={login}
			to={link ? to : false}
			statusVip={statusVip}
			size={fontSizes[size]}
			maxWidthWithEllipsis={maxWidthWithEllipsis}
			scrollForce={scrollForce}
			closeModal={closeModal}
			isProfile={isProfile}
			showUnverified={vipProps?.showUnverified && vip === 1}
			noUnderline={noUnderline}
			{...rest}
		/>
	);
};

// #####################################################

Login.displayName = "Login";

export default Login;

// #####################################################
